<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>
<script>
    export default {
        data: function () {
            return {

            }
        }
    }
</script>

<style>
  /*.app{
    text-align: center;
    width:460px;
    height:auto;
    margin: 210px auto 0 auto;
  }*/

</style>


// WEBPACK FOOTER //
// App.vue?4411c073